import React, { Fragment } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ModalHeader,
  ModalBody,
  Modal
} from "reactstrap";

export default class HomeHeroImages extends React.Component {
  constructor(props) {
    super(props);
    let images=props.images;
    //images.push("https://www.youtube.com/embed/tgbNymZ7vqY");
    this.state = { images: props.images, show_media_modal:null};
  }

  isStringImage(str) {
    if (str.startsWith("data:image")||str.endsWith(".png") || str.endsWith(".jpeg") || str.endsWith(".jpg") || str.endsWith(".gif")) {
      return 1;
    }
    else {
      return 0;
    }
  }

  render() {
    return (
      <Fragment>
        <div id="home_hero_div" className="w-100 d-flex pb-2" style={{ overflowX: "auto" }}>
          {this.state.images !== null && this.state.images !== undefined && this.state.images.map((media, mindex) => {
            if (this.isStringImage(media) === 0) {
              return <div style={{ cursor: "pointer", position: "relative" }} onClick={(e) => this.setState({ show_media_modal: media })}>
                                <div style={{height:"300px", minWidth:"100%", position:"absolute", zIndex:10}}></div>

                <iframe className="p-1" height="300" src={media} style={{border:"none"}}>
                </iframe>
              </div>
            }
            else {
              return <img className="p-1" src={media} alt="" style={{ height: "300px", cursor: "pointer" }} onClick={(e) => this.setState({ show_media_modal: media })} />
            }
          })}
        </div>

        <Modal zIndex={2000} size="lg" isOpen={this.state.show_media_modal === null ? false : true} style={{top:"80px"}}>
          <ModalHeader toggle={(e) => this.setState({ show_media_modal: null })} />
          <ModalBody>
            {this.state.show_media_modal !== null && this.isStringImage(this.state.show_media_modal) === 0 &&
              <iframe   allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen" 
              msallowfullscreen="msallowfullscreen" 
              oallowfullscreen="oallowfullscreen" 
              webkitallowfullscreen="webkitallowfullscreen" className="p-1" width="100%" height="500px" src={this.state.show_media_modal} style={{border:"none"}}>
              </iframe>
            }
            {this.state.show_media_modal !== null && this.isStringImage(this.state.show_media_modal) === 1 &&
              <img className="p-1" src={this.state.show_media_modal} alt="" style={{ height: "100%", width: "100%", cursor: "pointer" }} />
            }
          </ModalBody>
        </Modal>


      </Fragment>
    );
  }
}
